/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesQuoteResponseDto } from '../../models/sales-quote-response-dto';

export interface QuotesControllerRemoveTeamConfigurationItem$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the quote.
 */
  quoteId: string;

/**
 * The stable identifier of the team configuration item to remove (falls back to name for legacy items).
 */
  itemId: string;
}

export function quotesControllerRemoveTeamConfigurationItem(http: HttpClient, rootUrl: string, params: QuotesControllerRemoveTeamConfigurationItem$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuoteResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, quotesControllerRemoveTeamConfigurationItem.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('quoteId', params.quoteId, {});
    rb.path('itemId', params.itemId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesQuoteResponseDto>;
    })
  );
}

quotesControllerRemoveTeamConfigurationItem.PATH = '/o2-sales/quotes/{tenant}/{quoteId}/team-configuration/{itemId}';
